module.exports = __webpack_public_path__ + "img/winner_text_de.8f848f5b.svg";